<template>
	<sa-page-layout :btnBackVisible="false" :btnNewVisible="true" :btnRefreshVisible="true" :linkedit="linkedit" :showModalLoading="showModalLoading" @refresh="onRefresh">
		<template slot="table-body">
			<gestione-attivita-moduli-list-component ref="cmpGestioneAttivitaModuliListComponent" @beforeLoadData="onBeforeLoadDataGestioneAttivitaModuliListComponent" @afterLoadData="onAfterLoadDataGestioneAttivitaModuliListComponent"></gestione-attivita-moduli-list-component>
		</template>
	</sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/layout/components/SaPageLayout.vue";
import GestioneAttivitaModuliListComponent from "../components/GestioneAttivitaModuliListComponent.vue";
export default {
	components: { SaPageLayout, GestioneAttivitaModuliListComponent },
	data() {
		return {
			showModalLoading: false,
			linkedit: "moduli",
		};
	},
	mounted() {
		let me = this;
		me.$refs.cmpGestioneAttivitaModuliListComponent.init();
	},
	methods: {
		onBeforeLoadDataGestioneAttivitaModuliListComponent() {
			let me = this;
			me.showModalLoading = true;
		},
		onAfterLoadDataGestioneAttivitaModuliListComponent() {
			let me = this;
			me.showModalLoading = false;
		},
		onRefresh() {
			let me = this;
			me.$refs.cmpGestioneAttivitaModuliListComponent.init();
		},
	},
};
</script>

<style></style>
